<div class="dialog-container">
  <h2 class="dialog-container-title">{{ data.title }}</h2>

  <div class="dialog-container-search-input" [formGroup]="searchForm">
    <lib-andromeda-search-input
      [parentForm]="searchForm"
      formControlName="search"
      [placeholderValue]="'Rechercher'"
    ></lib-andromeda-search-input>
  </div>

  <div class="dialog-container-content">
    <div class="dialog-container-content-options-container">
      <label
        *ngFor="let option of filteredOptions"
        class="dialog-container-content-option-item"
      >
        <input
          type="checkbox"
          [checked]="selectedOption === option.uri"
          (change)="selectOption(option)"
        />
        <span>{{ option.label }}</span>
      </label>
    </div>
  </div>

  <div class="dialog-actions">
    <button class="dialog-actions-cancel-button" (click)="close()">
      Annuler
    </button>
    <button
      class="dialog-actions-validate-btn"
      (click)="save()"
      [disabled]="!selectedOption"
    >
      Valider
    </button>
  </div>
</div>
